module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "companyRegister"
    }
  }, [_c('div', {
    staticClass: "wrap container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container_right p_background"
  }, [_c('div', {
    staticClass: "container_right_info"
  }, [_c('section', {
    staticClass: "container_btm"
  }, [_c('div', {
    staticClass: "clearfix tb_padding"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("基本信息")]), _vm._v(" "), _c('span', {
    staticClass: "endnote"
  }, [_vm._v("\n\t\t\t\t\t\t    \t\t\t账号名称:\n\t\t\t\t\t\t    \t\t\t"), _c('i', [_vm._v(_vm._s(_vm.mob))])])]), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudUserCompany.mobile),
      expression: "tCloudUserCompany.mobile"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mob))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.companyName),
      expression: "tCloudUserCompany.companyName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "company_name",
      "placeholder": "请输入企业名称"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "companyName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("营业执照注册号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.companyNo),
      expression: "tCloudUserCompany.companyNo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_companyNo",
      "placeholder": "请输入营业执照注册号",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.companyNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "companyNo", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "id_card_box line_block",
    attrs: {
      "id": "company_no"
    }
  }, [_c('form', {
    staticClass: "inline-block",
    attrs: {
      "id": "subform",
      "enctype": "multipart/form-data",
      "method": "post",
      "action": "/zklccloud/uploadImages"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "type",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "cardPhoto",
      "readonly": "readonly"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left pos-relative file_box_btn text-center",
    attrs: {
      "id": "echoImgz"
    }
  }, [_c('input', {
    staticClass: "cursor",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "register_imgFilez"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPhotoz()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_font",
    attrs: {
      "src": _vm.echoImg,
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "id_card_text id_card_text_hidd"
  }, [_vm._v("点击上传营业执照")])])])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("联系地址：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudUserCompany.addressProvince),
      expression: "tCloudUserCompany.addressProvince"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addressprovince"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudUserCompany, "addressProvince", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '0', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.provinceOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(option.dictionaryname) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudUserCompany.addressCity),
      expression: "tCloudUserCompany.addressCity"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addresscity"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudUserCompany, "addressCity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '1', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.cityOptions), function(cityoption) {
    return _c('option', {
      domProps: {
        "value": cityoption.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cityoption.dictionaryname) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudUserCompany.addressStreet),
      expression: "tCloudUserCompany.addressStreet"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addressstreet"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudUserCompany, "addressStreet", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '2', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.streetOptions), function(streetoption) {
    return _c('option', {
      domProps: {
        "value": streetoption.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(streetoption.dictionaryname) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.addressDetails),
      expression: "tCloudUserCompany.addressDetails",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_addressdetail",
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.addressDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "addressDetails", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(6), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_vm._m(7), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserBankcard.bankNum),
      expression: "tCloudUserBankcard.bankNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control form_select",
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "name": "",
      "id": "bankNum"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudUserBankcard, "bankNum", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("请选择开户行")]), _vm._v(" "), _vm._l((_vm.bankOptions), function(bankoption) {
    return _c('option', {
      domProps: {
        "value": bankoption.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(bankoption.dictionaryname) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserBankcard.bankBranch),
      expression: "tCloudUserBankcard.bankBranch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户支行",
      "id": "bankBranch",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.tCloudUserBankcard.bankBranch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserBankcard, "bankBranch", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserBankcard.cardNo),
      expression: "tCloudUserBankcard.cardNo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "placeholder": "请输入银行卡号",
      "id": "bankCardNo"
    },
    domProps: {
      "value": (_vm.tCloudUserBankcard.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserBankcard, "cardNo", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserBankcard.cardUsername),
      expression: "tCloudUserBankcard.cardUsername",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户人姓名",
      "id": "cardUsername",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.tCloudUserBankcard.cardUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserBankcard, "cardUsername", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(12), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.companyContacts),
      expression: "tCloudUserCompany.companyContacts",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "company_contacts",
      "placeholder": "请输入联系人姓名"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.companyContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "companyContacts", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.email),
      expression: "tCloudUserCompany.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_email",
      "placeholder": "请输入电子邮箱"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "email", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(16), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mob))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("座机号码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.companyPhone),
      expression: "tCloudUserCompany.companyPhone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_spare",
      "placeholder": "请输入号码"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.companyPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "companyPhone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.qq),
      expression: "tCloudUserCompany.qq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_qq",
      "placeholder": "请输入QQ号码"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "qq", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("官网地址：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.tCloudUserCompany.companyUrl),
      expression: "tCloudUserCompany.companyUrl",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "register_blog",
      "placeholder": "请输入官网地址"
    },
    domProps: {
      "value": (_vm.tCloudUserCompany.companyUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudUserCompany, "companyUrl", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "developer_register_btn text-center"
  }, [_c('div', {
    staticClass: "issue_time_radio tip_sub_text"
  }, [_c('input', {
    staticClass: "radio_input_f",
    attrs: {
      "type": "checkbox",
      "checked": "",
      "name": "radio_issue_time",
      "id": "developer_register_radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form_label radio_label",
    attrs: {
      "for": "developer_register_radio"
    }
  }), _vm._v(" "), _c('span', [_vm._v("我已阅读并同意"), _c('a', {
    staticClass: "cursor btn_a",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.goAgreeMent
    }
  }, [_vm._v("《开发者用户服务协议》")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "btn btn_issue",
    on: {
      "click": _vm.frc
    }
  }, [_vm._v("注册")])])])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pushRoute),
      expression: "pushRoute"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.pushRoute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pushRoute = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slides-fade",
      "mode": "out-in"
    }
  }, [(_vm.infoFlage) ? _c('v-a-modal', {
    attrs: {
      "title": "协议详情",
      "linkSrc": "/agreement_company"
    },
    on: {
      "modalOff": function($event) {
        _vm.infoFlage = !_vm.infoFlage
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu_left"
  }, [_c('div', {
    staticClass: "menu_top menu_top_img"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo-register-info.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("开发者管理中心")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center h3"
  }, [_c('img', {
    staticClass: "margin_r_7",
    attrs: {
      "src": require("../assets/images/icon-enterprise-developers-t.png")
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t注册企业开发者\n\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("\n\t\t\t\t\t        \t\t\t\t\t（请与企业营业执照保持一致）\n\t\t\t\t\t        \t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("\n\t\t\t\t\t        \t\t\t\t\t（请与企业营业执照保持一致）\n\t\t\t\t\t        \t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("上传营业执照：")]), _vm._v(" "), _c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("\n\t\t\t\t        \t\t\t\t\t（jpg、png格式的图片，且不超过1M）\n\t\t\t\t        \t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("\n\t\t\t\t\t        \t\t\t\t\t（请与企业营业执照保持一致）\n\t\t\t\t\t        \t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("结算方式")]), _vm._v(" "), _c('span', {
    staticClass: "endnote"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("为必填项")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("开户行：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("开户支行：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("\n\t\t\t\t\t        \t\t\t\t\t（请务必正确填写开户支行）\n\t\t\t\t\t        \t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("卡号：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("姓名：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("联系方式")]), _vm._v(" "), _c('span', {
    staticClass: "endnote"
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("为必填项")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("联系人姓名：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("电子邮箱：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("（用于接收合作邮件及审核通知等重要信息）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("手机号码：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("（座机格式000-00000000）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("QQ：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "prompt_msg"
  }, [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("（方便在线实时沟通）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c1c6e924"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/company_register.vue
// module id = 1281
// module chunks = 1